import { createEntityAdapter } from '@reduxjs/toolkit'

import { RunsheetShiftTable } from '../model/runsheet/RunsheetShiftTable'

export const runsheetShiftTablesAdapter = createEntityAdapter({
  selectId: (table: RunsheetShiftTable) => table.shiftId,
})
